export const queryKeys = {
  TABLE: 'TABLE'
};
